import {Component, OnDestroy, ViewChild} from '@angular/core';
import {ClientService} from '../clients.service';
import {AuthService} from '../../../auth/auth.service';
import {Storage} from '@ionic/storage';
import * as moment from 'moment';
import {IndexClient} from '../../../models/client';
import {LocationService} from '../../../providers/locations.service';
import {ILocation} from '../../../models/location';
import {GlobalsService} from '../../../globals.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IonList, MenuController, ModalController, NavController} from '@ionic/angular';
import {ConsultationProvider} from '../../../providers/consultation.service';
import {InviteClientComponent} from '../client-invite/invite-client/invite-client.component';
import {listAnimation, listAnimation2} from '../../../animations/slideInListAnimation';
import * as _ from 'lodash';
import {Title} from '@angular/platform-browser';
import { MindbodyAppointmentsService } from 'src/app/providers/mindbody-appointments.service';
import { ToastService } from 'src/app/providers/toast.service';
import { CommonModalComponent } from 'src/app/components/common-modal/common-modal.component';
import { ListCardComponent } from 'src/app/components/list-card/list-card.component';
import { NoShowAppointmentsComponent } from 'src/app/components/no-show-appointments/no-show-appointments.component';
import { AwakenModal } from 'src/app/shared/awaken-modal/awaken-modal.component';

@Component({
  selector: 'app-client-index',
  templateUrl: './client-index.page.html',
  styleUrls: ['./client-index.page.scss'],
  animations: [
    listAnimation, listAnimation2
  ]
})
export class ClientIndexPage implements OnDestroy {
  Array = Array;
  clients: any[];
  date: string;
  location: number;
  appointmentTypes: string[];
  scheduleSort: string;
  isLoading = true;
  loadingLocations = true;
  isSearching = false;
  locations: ILocation[];
  userSubscription: Subscription;
  @ViewChild('clientList') clientList: IonList;

  constructor( public clientService: ClientService,
               private storage: Storage,
               private toastService: ToastService,
               private auth: AuthService,
               private locationService: LocationService,
               private mindbodyAppointmentsService: MindbodyAppointmentsService,
               private title: Title,
               private navCtrl: NavController,
               private globals: GlobalsService,
               private menuCtrl: MenuController,
               private router: Router,
               private modalCtrl: ModalController,
               private consultService: ConsultationProvider) {
    console.log(this)
  }

  ngOnDestroy() : void {
    this.userSubscription.unsubscribe()
  }

  ionViewWillEnter(): void {
    this.title.setTitle('Client Index')
    console.log('activate the menu')
    this.menuCtrl.enable(true, 'myMenu')
  }


  ionViewDidEnter() : void {
    this.setDay();
    this.getLocations();
    this.userSubscription = this.auth.current_user$.subscribe(
      val => {
        if (val?.employee) {
          this.scheduleSort = val.employee.client_sort_method
          this.location = val.employee.location_sort
          this.lookForClients();
        } else {
          this.auth.logout()
          this.navCtrl.navigateRoot('/login')
        }
      }
    );
  }

  /**
   * Sets the day for the schedule view of clients.
   */
  async setDay() : Promise<void> {
    await this.storage.ready()
    const storedOn = await this.storage.get('searchDateStoredOn')
    const date = await this.storage.get('date')
    if (moment(storedOn).isSame(moment(), 'day')) {
      this.date = date;
    } else {
      await this.storage.remove('date')
      this.date = moment().format()
    }
  }


  deleteClient(client: IndexClient) {
    this.clientService.deleteClient(client).subscribe()
  }


  /**
   * Fetch locations from storage and set them in the {@link LocationService}.
   */
  getLocations() : void {
    this.storage.get('locations').then((val) => {
      this.loadingLocations = false;
      this.locationService.setLocations(val)
    })
  }

  async markAppointmentAsNoShow(indexClient: IndexClient) {
    indexClient.no_show = true
    const data = {
      external_id: indexClient.external_id,
      location_id: indexClient.location_id,
      appointment_id: indexClient.external_id,
      no_show: true
    }

    try {
      const response = await this.mindbodyAppointmentsService.update(data).toPromise()
      // this.toastService.handleResponse("Marked appointment as no-show", false, 'success')
      return response
    } catch (err) {
      this.globals.handleResponse(err, true)
      return false
    }
  }

  async handleNoShowClient(indexClient: IndexClient) {
    console.log(indexClient);
    this.clientList.closeSlidingItems()
    if (!indexClient) return

    const updateAppointmentResponse = await this.markAppointmentAsNoShow(indexClient)
    if (!updateAppointmentResponse) {
      this.toastService.handleResponse("Error marking appointment as no-show", true)
      return
    }

    this.mindbodyAppointmentsService.getNoShows(indexClient).subscribe(
      async response => {
        const modal = await this.modalCtrl.create({
          component: CommonModalComponent,
          componentProps: {
            fullscreen: true,
            childComponent: {
              component: NoShowAppointmentsComponent,
              data: {
                updateAppointmentResponse,
                noShowAppointments: response,
                canBeRefreshed: false
              }
            }
          }, cssClass: 'large-modal'
        })
        await modal.present()
        const {data} = await modal.onDidDismiss()
        console.log(data);
        if (data?.sendEmail) {
          const appointment = {
            external_id: indexClient.external_id,
            location_id: indexClient.location_id,
            appointment_id: indexClient.external_id
          }
          this.mindbodyAppointmentsService.sendNoShowEmail(appointment, data.emailOption).subscribe(
            () => this.toastService.handleResponse("Sent message successfully", false, 'success'),
            err => this.toastService.handleResponse(err.error, true)
          )
        }

      },
      err => this.toastService.handleResponse(err.error, true)
    )
  }


  /**
   * Fetch daily clients from storage or from the server if storage is empty.
   * Set the value in storage if fetching from the server.
   */
  async lookForClients(newDate = null, force = false) : Promise<any> {
    this.isSearching = false;

    this.storage.ready().then(async () => {
      newDate = await this.storage.get('date')

      if (newDate) {
        this.date = newDate
      } else {
        this.date = moment().format('YYYY-MM-DD');
      }

      const search = `${this.location}_${this.date}`;

      this.storage.get( search ).then((val) => {
        if (_.isEmpty(val)) {
          this.clientService.getDailyClients(this.location, this.date, force).subscribe(
            success => {
              console.log('Got Daily Clients: ', success);
              this.appointmentTypes = Object.keys(success);
              this.clientService.setClients(success);
              this.storage.set(search, success);
              this.clientService.sortClients(this.scheduleSort);
              this.isLoading = false;
            },
            err => {
              if (err.status === 401) {
                this.storage.remove('current_user');
                this.storage.remove('location_id');
              }
              this.isLoading = false;
            },
            () => {
              this.isLoading = false;
            }
          )
        } else {
          console.log('Had Daily Clients: ', val);

          if ( Object.keys(val).length === 0 ) {
            console.log('had clients refresh');
            this.refresh({location: this.location, date: this.date, force: true})

          } else {
            this.clientService.setClients(val);
            this.appointmentTypes = Object.keys(val);
            this.clients = val;
            this.clientService.sortClients(this.scheduleSort);
            this.isLoading = false;
          }
        }
      })
    })
  }


  /**
   * Responds to emission from {@link ClientIndexSearchComponent}
   * @param params location: number, day: string, force: boolean
   */
  refresh(params: { location : number, date: string, force: boolean }) : void {
    console.log('refresh', params.date);

    this.date = moment(params.date).format('YYYY-MM-DD');

    const date = this.date;
    const query = `${params.location}_${date}`;
    this.isLoading = true
    this.location = params.location;
    this.storage.set('date', this.date)
    this.storage.set('searchDateStoredOn', moment().format())

    // if ( params.force ) {
      this.storage.remove(query).then(() => {
        this.storage.set('date', this.date);
        this.storage.set('location_id', params.location);
        this.lookForClients(this.date, params.force);
      })
    // } else {
      // console.log('no force')
      // this.lookForClients(this.date);
    // }
  }


  /**
   * Fetch the data for a client based on who was selected.
   * Redirect to the {@link ProfilePage} after loading.
   * @param id: Client ID to load
   */
  loadClient(id : number) : void {
    this.clientService.fetchClient( id ).subscribe(
      () => this.router.navigate(['clients', id, 'profile'])
    )
  }


  loadClientByUniqueMb(uniqueMb: number) : void {
    this.clientService.fetchClientByUniqueMb( uniqueMb ).subscribe(
      client => this.router.navigate(['clients', client.id, 'profile']),
      error => this.globals.handleResponse(error.error)
    )
  }


  /**
   * Fires when {@link ClientIndexRowComponent} emits client from the schedule and
   * generates consultation modal to facilitate in inviting the client.
   * @param client: New client to invite
   */
  async inviteClient( client : IndexClient ): Promise<any> {
    this.consultService.setConsultation(client.consultation);

    const modal = await this.modalCtrl.create({
      component: InviteClientComponent,
      componentProps: {
        consultClient: client,
        locationId: this.location,
        date: this.date
      },
      backdropDismiss: false,
      cssClass: 'modal-fullscreen'
    })

    return await modal.present()
  }



  inviteNewClient() : void {
    // let consult = new Consultation({})
    // this.consultService.setConsultation(consult);
    const consultClient = new IndexClient({
       id: null,
       name: null,
       user_id: null,
       location_id: null,
       mindbody_id: null,
       phone: null,
       appointment_type: null,
       email: null,
       found: null,
       time: null,
       referred_by: null,
       status: null,
       submitted: null,
       unique_mb: null,
       consult_status: null,
       consultation_id: null
    }, this.locationService)
    console.log(consultClient)

    this.modalCtrl.create({
      component: InviteClientComponent,
      componentProps: {
        consultClient,
        locationId: this.location
      },
      backdropDismiss: false,
      cssClass: 'modal-fullscreen'
    }).then( modal => modal.present());
  }
}
